export default {
  API_ENDPOINT: 'https://tranquil-forest-94312.herokuapp.com/api',
};
